module.exports = __webpack_public_path__ + "images/company_profile/icon_en06-c82e22ed4d265c745dbfa48625370cc7.png";